import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment-timezone';
import { TripService } from 'src/app/services/core/distributions/trip/trip.service';
import { onTimeChange } from 'src/app/utils/utils.common';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { sweetAlert } from 'src/app/utils/swal';
import { roundUp } from 'src/app/utils/common.utils';
@UntilDestroy()
@Component({
  selector: 'app-willcallmodal',
  templateUrl: './willcallmodal.component.html',
  styleUrls: ['./willcallmodal.component.css']
})
export class WillcallmodalComponent implements OnInit {

  willCallForm!: FormGroup;
  isSubmitted = false;
  @Input() user: any;
  @Input() willCallTrip: any;
  todayDate: any;
  @Output() closeModal = new EventEmitter<any>();
  @Output() onSave = new EventEmitter<any>();
  isExpected = false;

  constructor(
    private fb: FormBuilder,
    private tripService: TripService,
  ) { }

  ngOnInit(): void {
    this.willCallForm = this.fb.group({

      pickup: this.fb.group({
        time: ['', Validators.required],
      }),

      destination: this.fb.group({
        time: [''],
      }),

      flags: this.fb.group({
        isWillCallActivated: [true],
        // isExpected: [false]
      }),
      willCallNotes: [''],
    });

    if (this.user) {
      this.todayDate = moment().tz(this.user.timeZone || moment.tz.guess()).toISOString();

      this.willCallForm.patchValue({
        pickup: {
          time: this.willCallTrip.pickup.time
        }
      });
    }

  }

  get flagsGroup() {
    return this.willCallForm.get('flags') as FormGroup;
  }


  async onSubmit() {
    this.isSubmitted = true;

    await this.calculateMiles();

    if (this.willCallForm.valid) {
      const payload = this.willCallForm.value;
      this.onSave.emit(payload);
    }

    this.onCloseModal();
  }


  onCloseModal() {
    this.closeModal.emit();
  }

  toggleExpected(value: boolean) {
    this.isExpected = value;
    console.log('isExpected', this.isExpected);
    const flagsGroup = this.willCallForm.get('flags') as FormGroup;
    if (this.isExpected) {
      flagsGroup.patchValue({ isWillCallActivated: false });
    } else {
      flagsGroup.patchValue({ isWillCallActivated: true });

    }
  }

  onDateChange(controlName: AbstractControl<any, any> | null) {
    onTimeChange(controlName)
  }

  calculateMiles(): Promise<void> {
    return new Promise((resolve) => {
      let queryParam;
      let startCoords = this.willCallTrip?.pickup?.address?.coords || [];
      let endCoords = this.willCallTrip?.destination?.address?.coords || [];

      if (startCoords.length && endCoords.length) {
        queryParam = {
          start: [startCoords[0], startCoords[1]].toString(),
          end: [endCoords[0], endCoords[1]].toString(),
        };

        this.tripService.calculateMiles(queryParam)
          .pipe(untilDestroyed(this))
          .subscribe({
            next: (data: any) => {
              const segment = data.features[0]?.properties?.segments[0];

              let durationMinutes = 60;
              if (segment?.duration) durationMinutes = segment.duration / 60;
              console.log('durationMinutes', durationMinutes);

              const pickupTime = this.willCallForm.get('pickup.time')?.value;

              if (pickupTime) {
                const arrivalTime = moment(pickupTime)
                  .add(durationMinutes, "minutes")
                  .toISOString();

                this.willCallForm.patchValue({
                  destination: {
                    time: arrivalTime
                  }
                });
              }

              resolve();
            },
            error: () => {
              sweetAlert("Error", "Invalid Address", "error", "Ok");
              resolve();
            }
          });

      } else {
        resolve();
      }
    });
  }
}
